import React from "react";
import { Card, Button, Col, Row, Container } from "react-bootstrap";
import TutorialComponent from "./IoT";
import YouTube from "react-youtube";

const Projects = () => {
  const projects = [
    {
      title: "MultiVendor Site",
      description:
        "A multivendor ecommerce site that allows sellers to list their products and payments are made to the site owner. Built with MERN stack",
      image: "/project1.png",
      liveDemo: "https://broughtcargo.herokuapp.com",
      github: "https://github.com/example/project1",
    },
    {
      title: "Software Co Website",
      description:
        "Website for Edtek, a software development and consulting company based in Johanessburg South Africa. Built with React",
      image: "/project3.jpg",
      liveDemo: "https://tech-gui.github.io/edtekbeta/",
      github: "https://github.com/example/project2",
    },
    {
      title: "E-Commerce Website",
      description:
        "An online catalogue for an irrigation and farming equipment procurement company based in Johanessburg. Built with React",
      image: "/project2.png",
      liveDemo: "https://Tech-Gui.github.io/BJATSA-ecommerce",
      github: "https://github.com/example/project2",
    },

    {
      title: "Construction Co Website ",
      description:
        "Website for Mabocap, a construction company based in Mpumalanga South Africa. Built with React and I collaborated with Stephen",
      image: "/project3.png",
      liveDemo: "https://example.com/project2",
      github: "https://github.com/example/project2",
    },
  ];

  return (
    <div
      id="projects"
      style={{
        backgroundColor: "#f7f7f7",
        overflow: "hidden",
        minHeight: "100vh",
      }}
      className="d-flex justify-content-start align-items-center flex-column"
    >
      <div
        style={{
          backgroundColor: "rgb(15, 12, 31)",
          padding: "20px",
          width: "100%",
          color: "#fff",
          marginBottom: "3rem",
        }}
      >
        <h3 className="mb-2 text-center">Current Projects</h3>
        <p className="text-center">
          "Talk is cheap, show me the code"~ Tech Twitter
        </p>
      </div>

      <p className="text-center">
        Here are some projects that are am currently working on. All of them are
        for clients so I can not disclose the source code.
      </p>
      <Container>
        <Row className="mt-5 d-flex justify-content-center align-items-center ">
          {projects.map((project, index) => (
            <Col key={index} md={3} lg={3} xs={10} className="mb-4">
              <Card style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}>
                <div className="image-wrapper">
                  <Card.Img
                    variant="top"
                    src={process.env.PUBLIC_URL + project.image}
                  />
                </div>
                <Card.Body>
                  <Card.Title>{project.title}</Card.Title>
                  <Card.Text
                    className="text-muted mb-4"
                    style={{ fontSize: "small", textAlign: "justify" }}
                  >
                    {project.description}
                  </Card.Text>
                  <div className="button-container">
                    <Button
                      variant="primary"
                      href={project.liveDemo}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        background: "rgb(15, 12, 31)",
                        borderColor: "rgb(15, 12, 31)",
                        width: "100%",
                      }}
                    >
                      Live Demo
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      <div
        style={{
          backgroundColor: "rgb(15, 12, 31)",
          padding: "20px",
          width: "100%",
          color: "#fff",
          marginBottom: "3rem",
        }}
      >
        <h4 className="mb-2 text-center">IoT and Hardware Projects</h4>
      </div>

      <Col md={4} xs={10}>
        <Card
          style={{
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            width: "100%",
            marginTop: "2rem",
          }}
        >
          <div className="image-wrapper">
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/b-O2RINsrHU"
              title="Tutorial Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <Card.Body>
            <Card.Title>T Rex Runner</Card.Title>
            <Card.Text
              className="text-muted mb-4"
              style={{ fontSize: "small", textAlign: "justify" }}
            >
              In this comprehensive tutorial, learn how to recreate the iconic
              T-Rex Runner game using an LDR (Light Dependent Resistor) sensor
              and server automation. Follow along as we guide you through the
              step-by-step process of connecting the hardware components,
              including the LDR sensor and servo motor, to an Arduino board.
              Discover the fascinating world of game automation as I demonstrate
              how to automate key presses to control the T-Rex character,
              enabling it to effortlessly jump over cacti in the game. Join me
              on this exciting journey of blending hardware and software to
              create an interactive gaming experience. Expand your skills and
              unleash your creativity as we dive deep into the technical aspects
              and share invaluable insights along the way. Get ready to conquer
              the challenges and build your own version of the T-Rex Runner
              game. Let's embark on this thrilling adventure together!
            </Card.Text>
            <div className="button-container">
              <Button
                variant="primary"
                href=""
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  background: "rgb(15, 12, 31)",
                  borderColor: "rgb(15, 12, 31)",
                  width: "100%",
                }}
              >
                Learn More
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Col>

      <Col md={4} xs={10}>
        <Card
          style={{
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            width: "100%",
            marginTop: "2rem",
          }}
        >
          <div className="image-wrapper">
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/CoFb4rYSilc"
              title="Tutorial Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
          <Card.Body>
            <Card.Title>
              Interactive Game with 8-Segment LEDs and Push-Button: Test Your
              Skills
            </Card.Title>
            <Card.Text
              className="text-muted mb-4"
              style={{ fontSize: "small", textAlign: "justify" }}
            >
              In this engaging tutorial, you will learn how to create an
              interactive game using 8-segment LEDs and a push-button. The
              objective of the game is to test your skills and accuracy within a
              time limit of 60 seconds. Let's dive into the gameplay mechanics!
              Upon pressing the push-button for the first time, the game begins.
              Every 3 seconds, a random digit is displayed on the 8-segment LED
              display. Here's the exciting part: if the sum of the displayed
              digits since the last button press is divisible by 3, you should
              press the button to score 1 point. However, if the sum is not
              divisible by 3 and you mistakenly press the button, a penalty of
              -2 points is incurred. Once the time limit of 60 seconds is
              reached, your final score is displayed. Note that the score can
              exceed 10 points. The game offers two scenarios: (a) If your score
              ranges from 0 to 9, the LED display will briefly clear for 2
              seconds, followed by the display of your score for an additional 2
              seconds. This sequence repeats until the button is pressed again,
              signaling a game restart. (b) If your score surpasses 10 points,
              the LED display clears for 2 seconds, then the high digit of your
              score is shown for 2 seconds, followed by the low digit display
              for 2 seconds. The decimal point is displayed only with the lower
              digit. This cycle continues until the button is pressed for a
              fresh start. To provide feedback on your performance, a green LED
              light illuminates briefly when you correctly press the button,
              while a red LED light indicates an incorrect button press. Enjoy
              the challenge of improving your score! Remember, there are no
              negative scores throughout the game - zero is the minimum. So, for
              example, a player who scores 1 point, makes 3 incorrect presses,
              and then scores another point will have a total score of 1. Get
              ready to showcase your skills and test your timing accuracy in
              this interactive game with 8-segment LEDs and a push-button. Have
              fun and aim for the highest score!
            </Card.Text>
            <div className="button-container">
              <Button
                variant="primary"
                href=""
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  background: "rgb(15, 12, 31)",
                  borderColor: "rgb(15, 12, 31)",
                  width: "100%",
                }}
              >
                Learn More
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </div>
  );
};

export default Projects;
